

// Import all flag images
import inFlag from '../assets/flags/in.png';
import usaFlag from '../assets/flags/USA.png';
import ukFlag from '../assets/flags/UK.png';
import chFlag from '../assets/flags/ch.png';
import jaFlag from '../assets/flags/ja.png';
import geFlag from '../assets/flags/ge.png';
import brFlag from '../assets/flags/br.png';
import indoFlag from '../assets/flags/indo.png';
import ruFlag from '../assets/flags/ru.png';
import meFlag from '../assets/flags/me.png';
import viFlag from '../assets/flags/vi.png';
import skFlag from '../assets/flags/sk.png';
import frFlag from '../assets/flags/fr.png';
import caFlag from '../assets/flags/ca.png';
import auFlag from '../assets/flags/au.png';
import spFlag from '../assets/flags/sp.png';
import itFlag from '../assets/flags/it.png';
import phFlag from '../assets/flags/ph.png';
import thFlag from '../assets/flags/th.png';
import saFlag from '../assets/flags/sa.png';
import uaeFlag from '../assets/flags/UAE.png';
import poFlag from '../assets/flags/po.png';
import arFlag from '../assets/flags/ar.png';
import egFlag from '../assets/flags/eg.png';
import neFlag from '../assets/flags/ne.png';
import swFlag from '../assets/flags/sw.png';
import beFlag from '../assets/flags/be.png';
import siFlag from '../assets/flags/si.png';
import defaultFlag from '../assets/flags/default.png';

export const COUNTRIES = [
  { value: 'AR', label: 'Argentina', code: '+54', flag: arFlag },
  { value: 'AU', label: 'Australia', code: '+61', flag: auFlag },
  { value: 'BE', label: 'Belgium', code: '+32', flag: beFlag },
  { value: 'BR', label: 'Brazil', code: '+55', flag: brFlag },
  { value: 'CA', label: 'Canada', code: '+1', flag: caFlag },
  { value: 'CN', label: 'China', code: '+86', flag: chFlag },
  { value: 'EG', label: 'Egypt', code: '+20', flag: egFlag },
  { value: 'FR', label: 'France', code: '+33', flag: frFlag },
  { value: 'DE', label: 'Germany', code: '+49', flag: geFlag },
  { value: 'IN', label: 'India', code: '+91', flag: inFlag },
  { value: 'ID', label: 'Indonesia', code: '+62', flag: indoFlag },
  { value: 'IT', label: 'Italy', code: '+39', flag: itFlag },
  { value: 'JP', label: 'Japan', code: '+81', flag: jaFlag },
  { value: 'MX', label: 'Mexico', code: '+52', flag: meFlag },
  { value: 'NL', label: 'Netherlands', code: '+31', flag: neFlag },
  { value: 'PH', label: 'Philippines', code: '+63', flag: phFlag },
  { value: 'PL', label: 'Poland', code: '+48', flag: poFlag },
  { value: 'RU', label: 'Russia', code: '+7', flag: ruFlag },
  { value: 'SA', label: 'Saudi Arabia', code: '+966', flag: saFlag },
  { value: 'SG', label: 'Singapore', code: '+65', flag: siFlag },
  { value: 'KR', label: 'South Korea', code: '+82', flag: skFlag },
  { value: 'ES', label: 'Spain', code: '+34', flag: spFlag },
  { value: 'SE', label: 'Sweden', code: '+46', flag: swFlag },
  { value: 'TH', label: 'Thailand', code: '+66', flag: thFlag },
  { value: 'AE', label: 'UAE', code: '+971', flag: uaeFlag },
  { value: 'GB', label: 'United Kingdom', code: '+44', flag: ukFlag },
  { value: 'US', label: 'United States', code: '+1', flag: usaFlag },
  { value: 'VN', label: 'Vietnam', code: '+84', flag: viFlag },
  
];

// Helper function to get default flag
export const getDefaultFlag = () => defaultFlag;

export const US_STATES = [
  { value: 'AL', label: 'Alabama' }, { value: 'AK', label: 'Alaska' },
  { value: 'AS', label: 'American Samoa' }, { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' }, { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' }, { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' }, { value: 'DC', label: 'District Of Columbia' },
  { value: 'FM', label: 'Federated States Of Micronesia' }, { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' }, { value: 'GU', label: 'Guam' },
  { value: 'HI', label: 'Hawaii' }, { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' }, { value: 'IN', label: 'Indiana' }, // Note: State IN, Country US
  { value: 'IA', label: 'Iowa' }, { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' }, { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' }, { value: 'MH', label: 'Marshall Islands' },
  { value: 'MD', label: 'Maryland' }, { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' }, { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' }, { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' }, { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' }, { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' }, { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' }, { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' }, { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'OH', label: 'Ohio' }, { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' }, { value: 'PW', label: 'Palau' },
  { value: 'PA', label: 'Pennsylvania' }, { value: 'PR', label: 'Puerto Rico' },
  { value: 'RI', label: 'Rhode Island' }, { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' }, { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' }, { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' }, { value: 'VI', label: 'Virgin Islands' },
  { value: 'VA', label: 'Virginia' }, { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' }, { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

export const INDIAN_STATES = [
  { value: 'AN', label: 'Andaman and Nicobar Islands' }, { value: 'AP', label: 'Andhra Pradesh' },
  { value: 'AR', label: 'Arunachal Pradesh' }, { value: 'AS', label: 'Assam' },
  { value: 'BR', label: 'Bihar' }, { value: 'CH', label: 'Chandigarh' },
  { value: 'CT', label: 'Chhattisgarh' }, { value: 'DN', label: 'Dadra and Nagar Haveli' },
  { value: 'DD', label: 'Daman and Diu' }, { value: 'DL', label: 'Delhi' },
  { value: 'GA', label: 'Goa' }, { value: 'GJ', label: 'Gujarat' },
  { value: 'HR', label: 'Haryana' }, { value: 'HP', label: 'Himachal Pradesh' },
  { value: 'JK', label: 'Jammu and Kashmir' }, { value: 'JH', label: 'Jharkhand' },
  { value: 'KA', label: 'Karnataka' }, { value: 'KL', label: 'Kerala' },
  { value: 'LD', label: 'Lakshadweep' }, { value: 'MP', label: 'Madhya Pradesh' },
  { value: 'MH', label: 'Maharashtra' }, { value: 'MN', label: 'Manipur' },
  { value: 'ML', label: 'Meghalaya' }, { value: 'MZ', label: 'Mizoram' },
  { value: 'NL', label: 'Nagaland' }, { value: 'OR', label: 'Odisha' },
  { value: 'PY', label: 'Puducherry' }, { value: 'PB', label: 'Punjab' },
  { value: 'RJ', label: 'Rajasthan' }, { value: 'SK', label: 'Sikkim' },
  { value: 'TN', label: 'Tamil Nadu' }, { value: 'TG', label: 'Telangana' },
  { value: 'TR', label: 'Tripura' }, { value: 'UP', label: 'Uttar Pradesh' },
  { value: 'UT', label: 'Uttarakhand' }, { value: 'WB', label: 'West Bengal' },
];

// Mapping uses the 'value' from COUNTRIES ('US', 'IN', 'GB')
export const COUNTRY_STATE_MAPPING = {
  US: [], // Hide state for USA
  GB: [], // Hide state for UK
  IN: [], // Hide state for India
  // Add more countries and their states here
};

// Phone number validation regex based on country 'value' ('US', 'IN', 'GB')
export const PHONE_VALIDATIONS = {
  US: /^\d{10}$/, // 10 digits
  GB: /^\d{10,11}$/, // 10-11 digits
  IN: /^[6-9]\d{9}$/, // Starts with 6-9, 10 digits total
  CN: /^1[3-9]\d{9}$/, // Mobile: starts with 1, second digit 3-9, 11 digits total
  JP: /^0[789]0\d{8}$/, // Mobile: 0 + 7/8/9 + 0 + 8 digits
  DE: /^1[5-7]\d{8,9}$/, // Mobile: 1 + 5/6/7 + 8-9 digits
  BR: /^[1-9][1-9]\d{8,9}$/, // 10-11 digits, first two digits 11-99
  ID: /^8[1-9]\d{7,10}$/, // Mobile: 8 + 1-9 + 7-10 digits
  RU: /^[79]\d{9}$/, // Mobile: starts with 7 or 9, 10 digits
  MX: /^[1-9]\d{9}$/, // 10 digits, first digit 1-9
  VN: /^[3-9]\d{8}$/, // 9 digits, starts with 3-9
  KR: /^01[016789]\d{7,8}$/, // Mobile: 01 + 0/1/6/7/8/9 + 7-8 digits
  FR: /^[67]\d{8}$/, // Mobile: starts with 6 or 7, 9 digits
  CA: /^\d{10}$/, // 10 digits
  AU: /^[4-5]\d{8}$/, // Mobile: starts with 4 or 5, 9 digits
  ES: /^[6-7]\d{8}$/, // Mobile: starts with 6 or 7, 9 digits
  IT: /^3\d{8,9}$/, // Mobile: starts with 3, 9-10 digits
  PH: /^9[0-9]\d{8}$/, // Mobile: 9 + 0-9 + 8 digits
  TH: /^[689]\d{8}$/, // 9 digits, starts with 6/8/9
  SA: /^5[0-9]\d{7}$/, // Mobile: 5 + 0-9 + 7 digits
  AE: /^5[0-9]\d{7}$/, // Mobile: 5 + 0-9 + 7 digits
  PL: /^[5-8]\d{8}$/, // 9 digits, starts with 5-8
  AR: /^[1-9]\d{9,10}$/, // 10-11 digits, first digit 1-9
  EG: /^1[0-2]\d{8}$/, // Mobile: 1 + 0-2 + 8 digits
  NL: /^6\d{8}$/, // Mobile: starts with 6, 9 digits
  SE: /^7[0-9]\d{7}$/, // Mobile: 7 + 0-9 + 7 digits
  BE: /^4[0-9]\d{7}$/, // Mobile: 4 + 0-9 + 7 digits
  SG: /^[89]\d{7}$/, // 8 digits, starts with 8 or 9
};

// Basic email validation regex
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Map country code to currency code and symbol
export const COUNTRY_CURRENCY_MAP = {
  US: { currency: 'USD', symbol: '$', locale: 'en-US' },
  GB: { currency: 'GBP', symbol: '£', locale: 'en-GB' },
  IN: { currency: 'INR', symbol: '₹', locale: 'en-IN' },
  CN: { currency: 'CNY', symbol: '¥', locale: 'zh-CN' },
  JP: { currency: 'JPY', symbol: '¥', locale: 'ja-JP' },
  DE: { currency: 'EUR', symbol: '€', locale: 'de-DE' },
  BR: { currency: 'BRL', symbol: 'R$', locale: 'pt-BR' },
  ID: { currency: 'IDR', symbol: 'Rp', locale: 'id-ID' },
  RU: { currency: 'RUB', symbol: '₽', locale: 'ru-RU' },
  MX: { currency: 'MXN', symbol: '$', locale: 'es-MX' },
  VN: { currency: 'VND', symbol: '₫', locale: 'vi-VN' },
  KR: { currency: 'KRW', symbol: '₩', locale: 'ko-KR' },
  FR: { currency: 'EUR', symbol: '€', locale: 'fr-FR' },
  CA: { currency: 'CAD', symbol: 'C$', locale: 'en-CA' },
  AU: { currency: 'AUD', symbol: 'A$', locale: 'en-AU' },
  ES: { currency: 'EUR', symbol: '€', locale: 'es-ES' },
  IT: { currency: 'EUR', symbol: '€', locale: 'it-IT' },
  PH: { currency: 'PHP', symbol: '₱', locale: 'en-PH' },
  TH: { currency: 'THB', symbol: '฿', locale: 'th-TH' },
  SA: { currency: 'SAR', symbol: '﷼', locale: 'ar-SA' },
  AE: { currency: 'AED', symbol: 'د.إ', locale: 'ar-AE' },
  PL: { currency: 'PLN', symbol: 'zł', locale: 'pl-PL' },
  AR: { currency: 'ARS', symbol: '$', locale: 'es-AR' },
  EG: { currency: 'EGP', symbol: '£', locale: 'ar-EG' },
  NL: { currency: 'EUR', symbol: '€', locale: 'nl-NL' },
  SE: { currency: 'SEK', symbol: 'kr', locale: 'sv-SE' },
  BE: { currency: 'EUR', symbol: '€', locale: 'nl-BE' },
  SG: { currency: 'SGD', symbol: 'S$', locale: 'en-SG' },
};

/**
 * Get currency formatting info by country code
 * @param {string} countryCode - e.g. 'US', 'IN'
 * @returns {{currency: string, symbol: string, locale: string}}
 */
export function getCurrencyFormatByCountry(countryCode) {
  return COUNTRY_CURRENCY_MAP[countryCode] || COUNTRY_CURRENCY_MAP['US'];
}

/**
 * Helper function to get a country's flag emoji.
 * @param {string} countryValue - The value of the country (e.g., 'US', 'IN').
 * @returns {string | null} - The flag emoji string or null if not found.
 */
export const getCountryFlag = (countryValue) => {
  if (!countryValue) return null;
  const country = COUNTRIES.find(c => c.value === countryValue);
  return country ? country.flag : null;
};

/**
 * Helper function to get a country's display name from its code.
 * @param {string} countryCode - The country code (e.g., 'US', 'IN').
 * @returns {string} - The full country name or the code if not found.
 */
export const getCountryDisplayName = (countryCode) => {
  if (!countryCode) return 'Unknown';
  const country = COUNTRIES.find(c => c.value === countryCode);
  return country ? country.label : countryCode;
};
// --- END OF FILE Constants.js (Modified) ---